import { render } from "./UserSettingDropdown.vue?vue&type=template&id=032c7abb&scoped=true"
import script from "./UserSettingDropdown.vue?vue&type=script&lang=js"
export * from "./UserSettingDropdown.vue?vue&type=script&lang=js"

import "./UserSettingDropdown.vue?vue&type=style&index=0&id=032c7abb&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-032c7abb"

export default script